module.exports = __webpack_public_path__ + "img/icono_G1_ing.26f598ec.svg";